// ElectricPane
import React from "react";
import { num } from "../../../helpers/rooms.helpers";

export default function ElectricPane({ title, items, defaultSection, sections, onAdd, onChange, onRemove }) {
    return (
        <div className="smeta-rooms__electric-col">
            <div className="smeta-rooms__pane-head">
                <div className="smeta-rooms__sub-title-sm">{title}</div>
                <button type="button" className="smeta-rooms__btn smeta-rooms__btn--small" onClick={onAdd}>
                    + {title.slice(0, -1)}
                </button>
            </div>

            {(Array.isArray(items) ? items : []).map((p, pi) => (
                <div key={p.id || pi} className="smeta-rooms__row smeta-rooms__row--point">
                    <input
                        className="smeta-rooms__input"
                        value={p.label || ""}
                        onChange={(e) => onChange(pi, { label: e.target.value })}
                        placeholder="Тип/место"
                    />
                    <input
                        className="smeta-rooms__input smeta-rooms__input--sm"
                        value={p.qty ?? ""}
                        onChange={(e) => onChange(pi, { qty: num(e.target.value) })}
                        inputMode="numeric"
                        placeholder="шт"
                    />
                    <select
                        className="smeta-rooms__select smeta-rooms__select--sm"
                        value={String(p.cableSectionMm2 ?? defaultSection)}
                        onChange={(e) => onChange(pi, { cableSectionMm2: e.target.value })}
                    >
                        {sections.map((s) => (
                            <option key={String(s)} value={String(s)}>
                                {String(s)}
                            </option>
                        ))}
                    </select>
                    <button type="button" className="smeta-rooms__btn smeta-rooms__btn--tiny smeta-rooms__btn--danger" onClick={() => onRemove(pi)}>
                        x
                    </button>
                </div>
            ))}
        </div>
    );
}
